<template>
  <div class="role-card-create app__card">
    <button
      v-ripple
      class="role-card-create__btn app__button-flat"
      :disabled="formMixin.isDisabled"
      @click="retirectToRoleCreate"
    >
      {{ 'role-card-create.btn-create' | globalize }}
    </button>
  </div>
</template>

<script>
import RolesMixin from '@/vue/mixins/roles.mixin'

export default {
  name: 'role-card-create',
  mixins: [ RolesMixin ],
}
</script>

<style lang="scss" scoped>
.role-card-create {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 4rem;
  outline: dashed 0.2rem;
  outline-offset: -1.5rem;
  transition: 0.3s;
}

.role-card-create__btn {
  padding: 2.2rem;
  font-size: 1.6rem;
  font-weight: 600;
}
</style>
